import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var fixedArea = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_idwc3a1',variantClassNames:{side:{top:'fx_2d2fb1e5_idwc3a2',bottom:'fx_2d2fb1e5_idwc3a3'}},defaultVariants:{},compoundVariants:[]});

export { fixedArea };
//# sourceMappingURL=fixedArea.vanilla.mjs.map
